import type { PlaceholderData } from "@/components/lexical/placeholders"

export const EMAIL_TEMPLATE_PLACEHOLDERS: PlaceholderData[] = [
  {
    id: "current_date",
    label: "Current date",
    description: 'Example: "June 18, 2026". Uses the book timezone when available.',
    value: "{{ current_date }}",
    category: "General",
  },

  // Household attributes
  { id: "household_name", label: "Household name", value: "{{ household.name }}", category: "Household" },
  {
    id: "household_leader_preferred_names",
    label: "Leader first name(s)",
    description: 'Example: "John and Jane". If no spouse or partner, falls back to "John".',
    value: "{{ household.leader_preferred_names }}",
    category: "Household",
  },
  {
    id: "household_leader_first_names",
    label: "Leader first name(s) (legal)",
    description: 'Example: "John and Jane". Always uses legal first name, never preferred name.',
    value: "{{ household.leader_first_names }}",
    category: "Household",
  },
  {
    id: "household_next_meeting_at",
    label: "Next meeting start time",
    description: 'Example: "February 6 at 2pm"',
    value: "{{ household.next_meeting_at }}",
    category: "Household",
  },
  {
    id: "household_last_meeting_date",
    label: "Last meeting date",
    description: 'Example: "February 7, 2026"',
    value: "{{ household.last_meeting_date }}",
    category: "Household",
  },
  {
    id: "household_next_meeting_date",
    label: "Next meeting date",
    description: 'Example: "February 7, 2026"',
    value: "{{ household.next_meeting_date }}",
    category: "Household",
  },

  // Head of household attributes
  {
    id: "hoh_preferred_name",
    label: "HoH: first name",
    description: "Automatically falls back to preferred name if set.",
    value: "{{ household.head_of_household.preferred_name }}",
    category: "Head of household",
  },
  {
    id: "hoh_last_name",
    label: "HoH: last name",
    value: "{{ household.head_of_household.last_name }}",
    category: "Head of household",
  },
  {
    id: "hoh_full_name",
    label: "HoH: full name",
    value: "{{ household.head_of_household.full_name }}",
    category: "Head of household",
  },
  {
    id: "hoh_job_title",
    label: "HoH: job title",
    value: "{{ household.head_of_household.job_title }}",
    category: "Head of household",
  },

  // Spouse/partner attributes
  {
    id: "spouse_preferred_name",
    label: "Spouse/partner: first name",
    description: "Automatically falls back to preferred name if set.",
    value: "{{ household.spouse_or_partner.preferred_name }}",
    category: "Spouse/partner",
  },
  {
    id: "spouse_last_name",
    label: "Spouse/partner: last name",
    value: "{{ household.spouse_or_partner.last_name }}",
    category: "Spouse/partner",
  },
  {
    id: "spouse_full_name",
    label: "Spouse/partner: full name",
    value: "{{ household.spouse_or_partner.full_name }}",
    category: "Spouse/partner",
  },
  {
    id: "spouse_job_title",
    label: "Spouse/partner: job title",
    value: "{{ household.spouse_or_partner.job_title }}",
    category: "Spouse/partner",
  },

  // Sender attributes
  { id: "user_first_name", label: "Sender: first name", value: "{{ user.first_name }}", category: "Sender" },
  { id: "user_last_name", label: "Sender: last name", value: "{{ user.last_name }}", category: "Sender" },
  { id: "user_full_name", label: "Sender: full name", value: "{{ user.full_name }}", category: "Sender" },
  {
    id: "user_scheduling_link",
    label: "Sender: scheduling link",
    description: "The sender's personal scheduling link, or the book's if not set.",
    value: "{{ user.scheduling_link | default: book.scheduling_link }}",
    category: "Sender",
  },

  // Company attributes
  {
    id: "book_scheduling_link",
    label: "Book: scheduling link",
    value: "{{ book.scheduling_link }}",
    category: "Company",
  },
  { id: "company_name", label: "Company: name", value: "{{ company.name }}", category: "Company" },
]
